<div class="form-field">
  <h4 class="gul-font-color thick-font">{{label}}</h4>
  <div class="input-form-field">
    <ng-content select="[input]"></ng-content>
    <ng-content select="[suffix]"></ng-content>
    <span class="absolute" *ngIf="unit !== ''">{{unit}}</span>
  </div>
</div>
